import { applyPanel } from "./UiPanel";
import { PARCHMENT, LAYERS } from "./theme";
import { playUiClick } from "../audio/sfx";
import { isMobile, onMobileChange } from "./platform";
const PANEL_WIDTH = 200;
const DRAWER_WIDTH = 240;
const MAX_ROWS = 10;
// Kenney medals.png sprite sheet: 5 columns × 2 rows of non-square cells. Row/col below are 0-indexed.
const MEDALS_SHEET_URL = "/assets/sprites/medals.png";
const MEDALS_SHEET_WIDTH = 221;
const MEDALS_SHEET_HEIGHT = 152;
const MEDAL_SHEET_COLS = 5;
const MEDAL_SHEET_ROWS = 2;
const MEDAL_CELL_ASPECT = MEDALS_SHEET_WIDTH /
    MEDAL_SHEET_COLS /
    (MEDALS_SHEET_HEIGHT / MEDAL_SHEET_ROWS);
const MEDAL_ICON_HEIGHT = 18;
const MEDAL_ICON_WIDTH = MEDAL_ICON_HEIGHT * MEDAL_CELL_ASPECT;
const MEDAL_BY_RANK = {
    1: { row: 0, col: 2 },
    2: { row: 1, col: 1 },
};
let dom = null;
let collapsed = false;
let drawerOpen = false;
let lastKey = "";
let hasData = false;
let rowClickHandler = null;
export function setLeaderboardRowClickHandler(cb) {
    rowClickHandler = cb;
}
function createTrophyIcon(size) {
    const icon = document.createElement("span");
    icon.style.cssText = `font-size: ${size}px; line-height: 1; flex-shrink: 0;`;
    icon.textContent = "🏆";
    return icon;
}
// Desktop keeps the original always-visible top-left panel, with its header click toggling
// the row list collapsed/expanded. Mobile turns it into an off-canvas drawer (slides in from
// the left over the map) opened via a small floating trigger button — the drawer's own
// open/close already controls visibility, so the collapse affordance is hidden there and the
// list always renders in full once the drawer is open.
function applyLayout() {
    if (!dom)
        return;
    const { panel, body, header, chevron, toggleBtn, drawerOverlay } = dom;
    const mobile = isMobile();
    toggleBtn.style.display = mobile && hasData ? "flex" : "none";
    chevron.style.display = mobile ? "none" : "";
    // On mobile the header's click toggle is disabled (see the listener below), so it shouldn't
    // read (or be reachable) as a control either.
    header.disabled = mobile;
    body.style.display = mobile ? "" : collapsed ? "none" : "";
    if (mobile) {
        panel.style.top = "0";
        panel.style.left = "0";
        panel.style.width = `${DRAWER_WIDTH}px`;
        panel.style.height = "100%";
        panel.style.borderRadius = "0";
        panel.style.overflowY = "auto";
        panel.style.transition = "transform 0.25s ease";
        panel.style.transform = drawerOpen ? "translateX(0)" : "translateX(-100%)";
        drawerOverlay.style.display = drawerOpen ? "block" : "none";
    }
    else {
        panel.style.top = "12px";
        panel.style.left = "12px";
        panel.style.width = `${PANEL_WIDTH}px`;
        panel.style.height = "auto";
        panel.style.borderRadius = "";
        panel.style.overflowY = "";
        panel.style.transition = "";
        panel.style.transform = "none";
        drawerOverlay.style.display = "none";
    }
}
function getDom() {
    if (dom)
        return dom;
    const drawerOverlay = document.createElement("div");
    drawerOverlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: ${LAYERS.leaderboardBackdrop};
    background: rgba(0,0,0,0.45);
    display: none;
  `;
    drawerOverlay.addEventListener("click", () => {
        drawerOpen = false;
        applyLayout();
    });
    const toggleBtn = document.createElement("button");
    toggleBtn.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.leaderboardToggle};
    top: 12px;
    left: 12px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: none;
    align-items: center;
    justify-content: center;
    border: 1px solid ${PARCHMENT.highlightBorder};
    background: #d3bf8f;
    box-shadow: 0 4px 14px rgba(0,0,0,0.35);
  `;
    toggleBtn.appendChild(createTrophyIcon(16));
    toggleBtn.addEventListener("click", () => {
        playUiClick();
        drawerOpen = !drawerOpen;
        applyLayout();
    });
    document.body.appendChild(drawerOverlay);
    document.body.appendChild(toggleBtn);
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.leaderboardPanel};
    font-family: ui-sans-serif, system-ui, sans-serif;
    box-shadow: 0 6px 20px rgba(0,0,0,0.35);
    user-select: none;
  `;
    applyPanel(panel, "beige");
    const header = document.createElement("button");
    header.type = "button";
    header.style.cssText = `
    width: 100%;
    background: none;
    border: none;
    font: inherit;
    color: inherit;
    margin: 0;
    border-bottom: 1px solid ${PARCHMENT.divider};
    padding: 7px 12px 6px;
    display: flex;
    align-items: center;
    gap: 6px;
  `;
    const label = document.createElement("span");
    label.textContent = "Bestenliste";
    label.style.cssText = `
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${PARCHMENT.text};
    flex: 1;
  `;
    const chevron = document.createElement("span");
    chevron.style.cssText = `
    font-size: 10px;
    color: ${PARCHMENT.textMuted};
    transition: transform 0.15s;
  `;
    chevron.textContent = "▲";
    header.append(createTrophyIcon(12), label, chevron);
    const body = document.createElement("div");
    body.style.cssText = "padding: 6px 0 4px;";
    header.addEventListener("click", () => {
        if (isMobile())
            return;
        playUiClick();
        collapsed = !collapsed;
        body.style.display = collapsed ? "none" : "";
        chevron.style.transform = collapsed ? "rotate(180deg)" : "";
    });
    panel.append(header, body);
    document.body.appendChild(panel);
    dom = { panel, body, header, chevron, toggleBtn, drawerOverlay };
    applyLayout();
    onMobileChange(applyLayout);
    return dom;
}
function createMedalIcon(row, col) {
    const icon = document.createElement("div");
    icon.style.cssText = `
    width: ${MEDAL_ICON_WIDTH}px;
    height: ${MEDAL_ICON_HEIGHT}px;
    flex-shrink: 0;
    background-image: url('${MEDALS_SHEET_URL}');
    background-repeat: no-repeat;
    background-size: ${MEDAL_SHEET_COLS * 100}% ${MEDAL_SHEET_ROWS * 100}%;
    background-position: ${(col / (MEDAL_SHEET_COLS - 1)) * 100}% ${(row / (MEDAL_SHEET_ROWS - 1)) * 100}%;
    image-rendering: pixelated;
    filter: drop-shadow(0 1px 1.5px rgba(0, 0, 0, 0.4));
  `;
    return icon;
}
function renderRows(body, entries, currentUserId) {
    body.textContent = "";
    if (entries.length === 0) {
        const empty = document.createElement("div");
        empty.style.cssText = `
      color: ${PARCHMENT.textMuted};
      font-size: 11px;
      line-height: 1.4;
      padding: 8px 12px 6px;
    `;
        empty.textContent =
            "Noch keine Gebäude – sprich Unternehmen an! Jedes gewonnene Unternehmen erscheint als Gebäude in eurer Stadt.";
        body.appendChild(empty);
        return;
    }
    const visible = entries.slice(0, MAX_ROWS);
    for (let i = 0; i < visible.length; i++) {
        const entry = visible[i];
        const isCurrentUser = entry.userId === currentUserId;
        const rank = i + 1;
        const row = document.createElement("button");
        row.type = "button";
        row.style.cssText = `
      width: 100%;
      background: none;
      border: none;
      font: inherit;
      color: inherit;
      margin: 0;
      text-align: left;
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 4px 12px;
      ${isCurrentUser ? `background: ${PARCHMENT.highlightBg}; border-left: 2px solid ${PARCHMENT.highlightBorder};` : "border-left: 2px solid transparent;"}
    `;
        row.addEventListener("click", () => {
            playUiClick();
            rowClickHandler?.(entry.userId, entry.name);
        });
        const rankEl = document.createElement("span");
        rankEl.style.cssText = `
      font-size: 10px;
      font-weight: 700;
      color: ${rank <= 3 ? PARCHMENT.accent : PARCHMENT.textMuted};
      width: 16px;
      flex-shrink: 0;
      text-align: right;
    `;
        rankEl.textContent = `${rank}.`;
        const nameWrap = document.createElement("span");
        nameWrap.style.cssText = `
      display: flex;
      align-items: center;
      gap: 7px;
      flex: 1;
      min-width: 0;
    `;
        const nameEl = document.createElement("span");
        nameEl.style.cssText = `
      font-size: 11px;
      color: ${isCurrentUser ? PARCHMENT.text : PARCHMENT.textMuted};
      flex: 0 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `;
        nameEl.textContent = entry.name;
        nameWrap.appendChild(nameEl);
        const medal = MEDAL_BY_RANK[rank];
        if (medal)
            nameWrap.appendChild(createMedalIcon(medal.row, medal.col));
        const countEl = document.createElement("span");
        countEl.style.cssText = `
      font-size: 11px;
      font-weight: 600;
      color: ${rank <= 3 ? PARCHMENT.accent : PARCHMENT.textMuted};
      flex-shrink: 0;
    `;
        countEl.textContent = String(entry.buildingCount);
        row.append(rankEl, nameWrap, countEl);
        body.appendChild(row);
    }
    if (entries.length > MAX_ROWS) {
        const more = document.createElement("div");
        more.style.cssText = `
      color: ${PARCHMENT.textMuted};
      font-size: 10px;
      padding: 4px 12px 2px;
      text-align: center;
    `;
        more.textContent = `+${entries.length - MAX_ROWS} weitere`;
        body.appendChild(more);
    }
}
export function updateLeaderboard(entries, currentUserId) {
    const d = getDom();
    d.panel.style.display = "";
    hasData = true;
    applyLayout();
    const key = JSON.stringify(entries) + (currentUserId ?? "");
    if (key === lastKey)
        return;
    lastKey = key;
    renderRows(d.body, entries, currentUserId);
}
export function hideLeaderboard() {
    if (dom) {
        dom.panel.style.display = "none";
        dom.toggleBtn.style.display = "none";
        dom.drawerOverlay.style.display = "none";
    }
    hasData = false;
    drawerOpen = false;
    lastKey = "";
}
